import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import type { CreateUserFeedbackRequest } from '@coursera/grpc-types-userfeedback/coursera/proto/userfeedback/v1beta1/user_feedback_api';

import type { Product } from 'bundles/program-common/types/programCommon';

const feedbackMutation = gql`
  mutation feedbackMutation($responses: Object!) {
    FeedbackMutation(input: $responses, action: $action)
      @rest(path: "grpc/userfeedback/v1beta1/UserFeedbackAPI/CreateUserFeedback", method: "POST") {
      user_feedback
    }
  }
`;

type FeedbackMutationVars = { responses: CreateUserFeedbackRequest };

type Props = {
  onFeedbackSent: (productId: string, feedback: 'Yes' | 'No' | '') => void;
  userId: number;
  product: Product;
  trackingData: { [key: string]: any };
  feedbackContext: string;
};

type SendFeedbackProps = {
  prompt: string;
  feedback: 'Yes' | 'No' | '';
  negativeFeedbackReason?: string;
};

const useFeedbackAPI = ({ userId, trackingData, product, onFeedbackSent, feedbackContext }: Props) => {
  const [sendFeedbackMutation] = useMutation<
    { sendFeedback: (props: SendFeedbackProps) => void },
    FeedbackMutationVars
  >(feedbackMutation);

  const sendFeedback = async ({ prompt, feedback, negativeFeedbackReason }: SendFeedbackProps) => {
    await sendFeedbackMutation({
      variables: {
        responses: {
          userFeedback: {
            userId,
            feedbackTargetId: `${feedbackContext}/${product.id}`,
            prompt,
            feedback,
            metadata: {
              service: 'skillSet_recs',
              trackingData,
              negativeFeedbackReason,
            },
          },
        },
      },
    });
    onFeedbackSent(product.id, feedback);
  };

  return { sendFeedback };
};

export default useFeedbackAPI;
